'use client';
import { ReactNode, useEffect } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { useAuth } from '@/lib/auth';
import { SharedAppShell, type ShellConfig, type NavItem } from '@tb/ui/AppShell';

const NAV: NavItem[] = [
  {
    label: 'Главная',
    icon: 'grid',
    children: [{ href: '/', label: 'Обзор', match: '^/$', icon: 'grid' }],
  },
  {
    label: 'Профиль',
    icon: 'dna',
    children: [
      { href: '/my-profile', label: 'Мой профиль', match: '^/my-profile', icon: 'dna' },
      { href: '/results', label: 'Результаты', match: '^/results', icon: 'chart' },
    ],
  },
  {
    label: 'Карьера',
    icon: 'briefcase',
    children: [
      { href: '/applications', label: 'Заявки', match: '^/applications', icon: 'briefcase' },
    ],
  },
  {
    label: 'Развитие',
    icon: 'rocket',
    children: [
      { href: '/tests', label: 'Тесты', match: '^/tests', icon: 'puzzle' },
      { href: '/articles', label: 'Статьи', match: '^/articles', icon: 'book' },
    ],
  },
  {
    label: 'Аккаунт',
    icon: 'gear',
    children: [{ href: '/profile', label: 'Настройки', match: '^/profile$', icon: 'gear' }],
  },
];

export default function AppShell({ children }: { children: ReactNode }) {
  const router = useRouter();
  const pathname = usePathname();
  const { user, loading, logout } = useAuth();

  const isPublic =
    pathname === '/login' ||
    pathname === '/register' ||
    pathname === '/forgot-password' ||
    pathname === '/reset-password' ||
    pathname.startsWith('/design-preview') ||
    pathname.startsWith('/invite');

  useEffect(() => {
    if (!isPublic && !loading && !user) router.replace('/login');
  }, [isPublic, loading, user, router]);

  if (isPublic) return <>{children}</>;

  if (loading || !user) {
    return <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="text-sm text-slate-400">Загрузка…</div>
    </div>;
  }

  const config: ShellConfig = {
    brandLabel: 'Личный кабинет',
    nav: NAV,
    userName: [user.firstName, user.lastName].filter(Boolean).join(' ') || undefined,
    userEmail: user.email,
    onLogout: () => { logout(); router.replace('/login'); },
  };

  return <SharedAppShell config={config}>{children}</SharedAppShell>;
}
